import { useClerkImageUrl } from "../../hooks/useClerkImageUrl";

/**
 * The header profile-menu avatar: the agent's Clerk headshot when they have
 * one, else initials. Reads Clerk reactively so a change made on `/profile`
 * shows here at once, without a reload.
 */
export function HeaderAvatar({ initials }: { initials: string }) {
  const imageUrl = useClerkImageUrl();
  return (
    <span className="inline-flex size-8 items-center justify-center overflow-hidden rounded-full bg-pro-ledge text-[13px] font-semibold text-[oklch(0.18_0.05_165)]">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="size-full object-cover" />
      ) : (
        initials || "·"
      )}
    </span>
  );
}
